(function () {
  var MQ = window.matchMedia('(max-width: 989px)');

  function init() {
    var contentCol = document.querySelector('.article__content-col');
    var hero = document.querySelector('.article__hero');
    var side = document.querySelector('.article__top-side');
    if (!contentCol || !hero || !side) return;

    var share = side.querySelector('.article__share-top');
    var toc = side.querySelector('.article-toc');

    // Plaats vaste ankers op de desktop-locatie van share en toc
    var shareAnchor = null, tocAnchor = null;
    if (share) {
      shareAnchor = document.createComment('share-anchor');
      share.parentNode.insertBefore(shareAnchor, share);
    }
    if (toc) {
      tocAnchor = document.createComment('toc-anchor');
      toc.parentNode.insertBefore(tocAnchor, toc);
    }

    function toMobile() {
      // volgorde in content-kolom: direct na de hero -> share, dan toc
      if (share) contentCol.insertBefore(share, hero.nextSibling);
      if (toc) contentCol.insertBefore(toc, share ? share.nextSibling : hero.nextSibling);
      if (toc) enableCollapse(toc);
    }

    function toDesktop() {
      // terug naar de ankers in de sidebar
      if (share && shareAnchor) shareAnchor.parentNode.insertBefore(share, shareAnchor.nextSibling);
      if (toc && tocAnchor) tocAnchor.parentNode.insertBefore(toc, tocAnchor.nextSibling);
      if (toc) disableCollapse(toc);
    }

    function apply() {
      if (MQ.matches) toMobile();
      else toDesktop();
    }

    apply();
    MQ.addEventListener ? MQ.addEventListener('change', apply) : MQ.addListener(apply);
  }

  function enableCollapse(toc) {
    toc.classList.add('article-toc--collapsible', 'is-collapsed');
    if (toc.__collapseBound) return;
    var title = toc.querySelector('.toc-content__menu-title');
    if (!title) return;
    title.setAttribute('role', 'button');
    title.setAttribute('tabindex', '0');
    var toggle = function () { toc.classList.toggle('is-collapsed'); };
    title.addEventListener('click', toggle);
    title.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
    toc.__collapseBound = true;
  }

  function disableCollapse(toc) {
    toc.classList.remove('article-toc--collapsible', 'is-collapsed');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();